import { render, staticRenderFns } from "./GridTextBox.vue?vue&type=template&id=2fdae9d1&scoped=true&"
var script = {}
import style0 from "./GridTextBox.vue?vue&type=style&index=0&id=2fdae9d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdae9d1",
  null
  
)

export default component.exports